export default "__VITE_ASSET__CTshhIQ7__"